import React from 'react';
import { Link } from 'react-router-dom';
import { Spinner } from '../../components/ui';
import { fmtDate, fmtTime, money } from '../../utils/helpers';
import { isPerUnit } from '../services/useServices';
import '../../styles/money.css';

const statusChip = (s) => s === 'Done' ? 'chip ok' : s === 'Confirmed' ? 'chip male' : s === 'Cancelled' ? 'chip danger' : 'chip pend';

// Mobile "My Work" — the owner's own jobs: when, where, how many, how much.
export default function MyWorkMobile({ vm }) {
  const { byEvent, rows, totals, loading, savingId, confirmCount, mapsHref, user } = vm;

  // − / + beside each count box (the box stays uncontrolled: Confirm reads it).
  const bump = (id, d) => {
    const el = document.getElementById(id);
    if (el) el.value = String(Math.max(0, (Number(el.value) || 0) + d));
  };

  if (loading) return <div className="card card-pad"><Spinner /></div>;

  return (
    <div>
      <div className="mobile-toolbar">
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <strong style={{ fontSize: 16 }}>My Work</strong>
          <span className="muted" style={{ fontSize: 12 }}>{rows.length}</span>
        </div>
        <div className="muted" style={{ fontSize: 12 }}>{[user?.Surname, user?.Name].filter(Boolean).join(' ')}</div>
      </div>

      {rows.length === 0 ? (
        <div className="card card-pad empty" style={{ padding: '26px 16px' }}>
          <div style={{ fontSize: 30 }}>📋</div>
          <div style={{ fontWeight: 700, color: 'var(--ink)', marginTop: 6 }}>Nothing assigned yet</div>
          <div style={{ fontSize: 13, marginTop: 4 }}>When the organiser books you for a function it appears here.</div>
        </div>
      ) : (
        <>
          <div className="mn-tiles m">
            <div className="mn-tile"><span>Agreed</span><strong>{money(totals.total)}</strong></div>
            <div className="mn-tile ok"><span>Received</span><strong>{money(totals.paid)}</strong></div>
            <div className="mn-tile due"><span>Pending</span><strong>{money(totals.balance)}</strong></div>
          </div>

          {byEvent.map(ev => (
            <div key={ev.EventId}>
              <div className="step-label" style={{ marginTop: 10 }}>{ev.EventName}</div>
              <div className="mobile-card-list">
                {ev.items.map(row => {
                  const maps = mapsHref(row);
                  return (
                    <div key={row.ServiceId} className="card card-pad mobile-record-card">
                      <div className="mobile-card-head">
                        <div style={{ minWidth: 0 }}>
                          <strong className="mobile-title">{row.FunctionName || 'Whole event'}</strong>
                          <div className="muted" style={{ fontSize: 12 }}>{row.ServiceType}</div>
                        </div>
                        <div style={{ flex: 1 }} />
                        <span className={statusChip(row.Status)}>{row.Status}</span>
                      </div>
                      <div className="mobile-meta">
                        <div>📅 {fmtDate(row.FunctionDate || row.ServiceDate)}</div>
                        <div>🕒 {fmtTime(row.StartTime || row.FunctionStartTime) || '—'}
                          {(row.EndTime || row.FunctionEndTime) ? ` – ${fmtTime(row.EndTime || row.FunctionEndTime)}` : ''}</div>
                        {(row.Venue || row.City) && <div>📍 {[row.Venue, row.VenueAddress, row.City].filter(Boolean).join(', ')}</div>}
                        {maps && <div><a href={maps} target="_blank" rel="noreferrer">🗺️ Open in Maps</a></div>}
                        {isPerUnit(row.RateType) && (
                          <div>{money(row.Rate)} × <strong>{row.ConfirmedCount}</strong></div>
                        )}
                      </div>
                      <div className="mn-money3">
                        <div><span>Agreed</span><strong>{money(row.TotalAmount)}</strong></div>
                        <div className="ok"><span>Received</span><strong>{money(row.AdvancePaid)}</strong></div>
                        <div className={Number(row.BalanceAmount) > 0 ? 'due' : ''}><span>Pending</span><strong>{money(row.BalanceAmount)}</strong></div>
                      </div>

                      {isPerUnit(row.RateType) && row.Status !== 'Done' && (
                        <div className="mn-count-row">
                          <div className="mn-stepper">
                            <button type="button" aria-label="Less" onClick={() => bump(`cnt-${row.ServiceId}`, row.RateType === 'PerPlate' ? -10 : -1)}>−</button>
                            <input type="number" inputMode="numeric" defaultValue={row.ConfirmedCount}
                              id={`cnt-${row.ServiceId}`} aria-label="Count you will serve" />
                            <button type="button" aria-label="More" onClick={() => bump(`cnt-${row.ServiceId}`, row.RateType === 'PerPlate' ? 10 : 1)}>+</button>
                          </div>
                          <button className="btn primary" disabled={savingId === row.ServiceId}
                            onClick={() => confirmCount(row, document.getElementById(`cnt-${row.ServiceId}`).value)}>
                            {savingId === row.ServiceId ? '…' : 'Confirm'}
                          </button>
                        </div>
                      )}
                      <div className="mobile-actions">
                        <Link className="btn light sm" to={`/app/services/${row.ServiceId}`}>Menu / jobs</Link>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </>
      )}
    </div>
  );
}
